// libs
import React from "react";

// styled
import { Loading, StyledCardContainer } from "./styled";

const LoadingScreen = () => {
    return (
        <>
            <StyledCardContainer
                $placement="top"
                elevation
                cornerRadius="medium"
                customPadding={{ left: 16, right: 16, top: 16, bottom: 20 }}
            >
                <Loading />
                <Loading />
                <Loading />
                <Loading />
            </StyledCardContainer>
            <StyledCardContainer $placement="bottom" customPadding={{ left: 16, right: 16, top: 24, bottom: 20 }}>
                <Loading />
                <Loading />
                <Loading />
                <Loading />
            </StyledCardContainer>
        </>
    );
};

export default LoadingScreen;
